export default __webpack_public_path__ + "static/media/gas-station.82fc1f1d.png";